import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import WalletStatusList from "./List";
import NotFound from "../../NotFound";

import { PageHeader } from "../../Shared";

import { walletStatusActions } from "./actions/walletstatus.actions";

export class WalletStatus extends Component {
  componentDidMount() {
    this.getWalletStatus();
  }

  getWalletStatus = params => {
    if (params) {
      this.props.getWalletStatus(params);
    }
  };

  render() {
    const { fetching, fetched, response, error, match } = this.props;
    return (
      <div className="WalletStatus">
        <Row>
          <Col>
            <PageHeader pageId="walletStatus" pageTitle="Check Wallet Status" />
          </Col>
        </Row>

        <div className="content-wrapper">
          <Switch>
            <Route
              exact
              path={match.url}
              render={() => (
                <WalletStatusList
                  match={match}
                  data={response}
                  loadData={this.getWalletStatus}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.walletStatus;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getWalletStatus: bindActionCreators(walletStatusActions.getWalletStatus, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WalletStatus);
